module.exports = function(response) {

  if (typeof axios!=='undefined')
    return response.data;

  return response;

}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/get-response-data.js